<div   *ngIf="!isLoading" style="display: flex;"  >
    <p *ngIf="isUpdate">Last updated: {{isUdpatedDate |date }} {{isUdpatedDate |date  : "shortTime" }}</p>
    <p *ngIf="!isUpdate">Update is in progress</p>
    <img *ngIf="!isUpdate"  class="rotate" src="assets/images/rotate-gree-icon.svg"/>
    <mat-icon class="refresh-icon"*ngIf="isUpdate" (click)="$event.stopPropagation();startReportExecution(report.id)"  >refresh</mat-icon>
</div>
<div *ngIf="isLoading" class="ph-item" style="padding: 0px;margin-bottom: 0px;
border: 0px;">
    <div class="ph-col-12" style="padding: 0px;">
        <div class="ph-row">
            <div class="ph-col-12"></div>
        </div>
    </div>
</div>